/* Increase specificity to outrank Reefer */
.heart.heart {
  width: var(--card-image-action-icon-size, 20px);
  height: var(--card-image-action-icon-size, 20px);
}
